import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'

export interface softUserStatRequestParams {
  /** 是否只查正版软件 0-否 1-是 */
  authenticsoft_flag?: number
}

export interface softUserStatResponseData {
 /** 今日活跃软件（今天有使用过的软件数量） */
  active_count?: number
  /** 已安装软件数(团队安装的软件数量) */
  install_count?: number
  /** 最高频率使用软件 */
  max_times_soft?: string
  /** 闲置软件（近7天未使用过的软件数量） */
  total_count?: number
}
export interface softTypeDurationStatRequestParams {
  /** 开始时间（Unix 时间戳，秒） */
  start_time: string
  /** 结束时间（Unix 时间戳，秒） */
  end_time: string
}

export interface softTypeDurationStatList {
  /** 软件类型 id */
  group_id: number
  /** 软件类型名称 */
  group_name: string
  /** 占比 (0-100 之间的百分比) */
  percentage: number
}

export interface softTypeDurationStatResponseData {
  /** 软件类型时长占比统计列表 (Top10) */
  list: softTypeDurationStatList[]
}
export interface activityRequestParams {
  /** 开始时间（Unix时间戳，秒） */
  start_time: string
  /** 结束时间（Unix时间戳，秒） */
  end_time: string
  /** 统计粒度：hour-按小时统计，day-按天统计 */
  granularity: string
}

export interface activityResponseData {
  /** 时间标签数组（Unix 时间戳，秒） */
  time_labels: string[]
  /** 软件使用次数数组 */
  usage_counts: number[]
}

/** 软件使用统计列表（软件维度）→ `POST /softmgr/userecord/soft-list` */
export interface UserecordRequestParams {
  /** 开始时间 */
  start_time: number
  /** 结束时间 */
  end_time: number
  page: number
  limit: number
  /** 是否升序 */
  asc?: boolean
  /** 终端id */
  device_id?: string
  /** 软件分组id */
  soft_group_id?: number
  /** 软件名称 */
  soft_name?: string
  /** 排序字段 */
  sort?: string
  /** 仅闲置软件列表：传 1 */
  idle_only?: number
}

export interface UserecordList {
  /** 软件名称 */
  soft_name: string
  /** 日均使用时长（分钟） */
  avg_duration?: number
  /** 日均使用次数 */
  avg_use_count?: number
  /** 安装时间（最新安装时间） */
  install_time?: number
  /** 软件的安装总数（当前未卸载） */
  install_total_count?: number
  /** 最后活跃时间 */
  last_active_time?: number
  /** 软件版本 */
  soft_version?: string
  /** 软件今日活跃终端数 */
  today_active_count?: number
  /** 以下字段由接口返回时用于详情、旧版表格兼容 */
  soft_id?: number
  soft_hash_key?: string
  logo_url?: string
  /** 使用终端数（与旧版列表一致时由接口返回） */
  terminal_count?: number
  soft_group_name?: string
  soft_type:number|string
}

export interface UserecordResponseData {
  /** 返回数据 */
  list: UserecordList[]
  /** 总数 */
  total: number
  /** 当前页 */
  page: number
}
@Injectable()
export class SoftManageService {
  constructor(private http: Http) { }

  getSoftmgrSoftTypeDurationStat(data: softTypeDurationStatRequestParams) {
    return this.http.post<softTypeDurationStatResponseData>('/softmgr/soft-type-duration-stat', data)
  }
  getSoftmgrSoftUseStat(data: softUserStatRequestParams) {
    return this.http.post<softUserStatResponseData>('/softmgr/soft-use-stat', data)
  }
  getSoftmgrSoftActivityStat (data: activityRequestParams) {
    return this.http.post<activityResponseData>('/softmgr/soft-activity-stat', data)
  }
  /** 软件列表：名称、活跃终端、安装数、日均时长/次数、最后活跃时间等 */
  @ParamsClean()
  getSoftmgrUserecordSoftList (data: UserecordRequestParams) {
    return this.http.post<UserecordResponseData>('/softmgr/userecord/soft-list', data)
  }
}
